// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/animations","fadeIn":"animations-m__fadeIn__1Gpxv","fadeOut":"animations-m__fadeOut__ClAlv"};